import React, { Component, Fragment } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { withRouter } from "react-router-dom";


import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/KeyboardBackspace";
import Slide from "@material-ui/core/Slide";
import { connect } from "react-redux";
import axios from "axios";
import CustomizedProgressBars from "./spinner";
import TextField from "@material-ui/core/TextField";
import "./item.css";
import Divider from "@material-ui/core/Divider";
import { CookieName, getCookie } from "../utils/cookieManager";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class INBOX extends Component {
  giveEmail=()=>{
    let uemail="";
    if(getCookie(CookieName.USEREMAIL)){
      uemail=getCookie(CookieName.USEREMAIL)
    }
    return uemail;
  }
  
  
  state = {
    open: false,
    mob: "",
    pnr: this.props.pnr,
    coach: "",
    seat: "",
    email:this.giveEmail(),
    isLoading: false,
    error: "",
    BookingDetails: "",
    errormob: "",
    errorpnr: "",
    errorcoach: "",
    errorseat: "",
    erroremail: ""
  };

  minR = () => {
    alert("Minimum order should be of ₹" + this.props.match.params.minOrder);
  };

  handleClickOpen = () => {
    this.setState({
      open: true
    });
  };

  handleClose = () => {
    this.setState({ open: false, error: "" });
  };
  // handleClose2 = () => {
  //   this.setState({ error: "" });
  // };

  back = () => {
    this.props.history.goBack();
  };

  myChangeHandler = event => {
    let nam = event.target.name;
    let val = event.target.value;
    if (nam === "mob") this.setState({ [nam]: val, errormob: "" });
    else if (nam === "pnr") this.setState({ [nam]: val, errorpnr: "" });
    else if(nam==="email") this.setState({ [nam]: val, erroremail: "" })
    else if (nam === "seat") this.setState({ [nam]: val, errorseat: "" });
    else if (nam === "coach") this.setState({ [nam]: val, errorcoach: "" });
    
  };

  check = () => {
    let numbers = /^[0-9]+$/;
    let  regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


    if (this.state.mob.length !== 10 || !this.state.mob.match(numbers)) {
      this.setState({
        errormob: "Enter correct mobile no."
      });
      return false;
    }
    if (this.state.pnr.length !== 10 || !this.state.pnr.match(numbers)) {
      this.setState({
        errorpnr: "Enter correct PNR no."
      });
      return false;
    }
    if (this.state.email === "" || !regEx.test(String(this.state.email).toLowerCase())) {
      this.setState({
        erroremail: "Enter correct email ID."
      });
      return false;
    }

    if (this.state.coach === "") {
      this.setState({
        errorcoach: "Enter coach no."
      });
      return false;
    }
    if (this.state.seat <= 0) {
      this.setState({
        errorseat: "Enter correct Seat no."
      });
      return false;
    }

    return true;
  };

  PlaceOrder = () => {
    if (this.check()) {
      this.setState({ isLoading: true });
      let userOrderMenu = [];
      for (var key in this.props.cart) {
        if (this.props.cart[key] !== undefined) {
          let ob = {
            itemId: this.props.cart[key].itemId,
            itemName: this.props.cart[key].itemName,
            basePrice: this.props.cart[key].basePrice,
            description: this.props.cart[key].description,
            quantity: this.props.cart[key].quantity,
            tkServiceTax: this.props.cart[key].serviceTax,
            itemCustomerPayable: this.props.cart[key].customerPayable,
            SwachhBharatCess: 0,
            KrishiKalyanCess: 0,
            isVegetarian: this.props.cart[key].isVegeterian,
            isNonVegetarian: this.props.cart[key].isNonVegeterian,
            foodType: this.props.cart[key].foodType,
            cuisine: this.props.cart[key].cuisine
          };
          userOrderMenu.push(ob);
        }
      }
      // console.log(userOrderMenu);
      let userOrderInfo = {
        delivery_cost: this.props.match.params.delC,
        cod: "1",
        online_pay_status: "0",
        order_outlet_id: this.props.match.params.outletId,
        discount: "",
        voucher_code: "",
        adv_option: "",
        outletName: this.props.match.params.outletName,
        adv_txn_id: "",
        adv_bank: "",
        adv_pay_date: "",
        date: this.props.match.params.doj,
        pnr: this.state.pnr,
        advance_amount: "0",
        station_code: this.props.match.params.stationCode,
        train_no: this.props.match.params.trainNO,
        coach: this.state.coach,
        seat: this.state.seat,
        customer_comment: "No Comment",
        totalCustomerPayable: this.props.topay,
        KrishiKalyanCess: "0",
        SwachhBharatCess: "0",
        tkServiceTax: this.props.tax
      };
      //  console.log(userOrderInfo);
      let uname="";
      if(getCookie(CookieName.USERNAME))
        uname=getCookie(CookieName.USERNAME);
      
      let userBasicInfo = {
        login_id: "",
        name:uname,
        contact_no:this.state.mob,
        mail_id: this.state.email
      };

      console.log(this.props.match.params.trainN);
      let trainUpdateInfo = {
        train_number: this.props.match.params.trainNO,
        station_code: this.props.match.params.stationCode,
        date: this.props.match.params.doj,
        trainName: this.props.match.params.trainN,
        stationName: this.props.match.params.StaN,
        sta: this.props.match.params.sta,
        eta: this.props.match.params.sta
      };

      const postObject = {
        userOrderMenu: userOrderMenu,
        userOrderInfo: userOrderInfo,
        userBasicInfo: userBasicInfo,
        trainUpdateInfo: trainUpdateInfo
      };

      console.log(postObject);
      const uTOKEN = getCookie(CookieName.USERTOKEN)?getCookie(CookieName.USERTOKEN):"";
      console.log(uTOKEN);

   
        axios
          .post(
            "https://securedapi.confirmtkt.com/api/platform/foodbooking/bookfoodnew?provider=RailRestro&authToken=" +
            uTOKEN +"&device=mweb",
            postObject
          )
          .then(response => {
            // console.log(response.data);
            this.setState({
              isLoading: false,
              BookingDetails: response.data
            });
            if (response.data.BookingId) {
              console.log("placed");
              this.props.history.push(
                "/food-booking/order/" +
                  response.data.BookingId 
                 
                  +"/"+this.state.email
              );
            } else {
              console.log("not placed");
              console.log(response.data.Error);
              this.setState({
                isLoading: false,
                error: response.data.Error
              });
            }
          })

          .catch(error => {
            //  console.log(error);
            //  console.log("order error");
            this.setState({
              isLoading: false,
              error: "Something went wrong"
            });
          });
      
      //  else{
      //   alert(" Fill All  details Correctly");
      //  }
    }
    // else
  };

  render() {
    let x = [];
    for (var key in this.props.cart) {
      if (this.props.cart[key] !== undefined) {
        let z = (
          this.props.cart[key].quantity * this.props.cart[key].customerPayable
        ).toFixed(2);
        x.push(
          <Grid
            item
            xs={12}
            style={{ padding: 5 }}
            key={this.props.cart[key].itemId}
          >
            <Grid container style={{ paddingLeft: 5 }}>
              <Grid item xs={6}>
                {this.props.cart[key].itemName}
              </Grid>

              <Grid item xs={2} style={{ float: "right" }}>
                <span> {this.props.cart[key].quantity}</span>
              </Grid>

              <Grid item xs={4} style={{ float: "right" }}>
                <span style={{ float: "right", marginRight: 5 }}> ₹{z} </span>
              </Grid>
            </Grid>
          </Grid>
        );
      }
    }

    let result;
    if (this.state.isLoading === false) {
      if (this.state.error === "") {
        result = (
          <Fragment>
            <Grid
              container
              style={{
                position: "fixed",
                backgroundColor: "white",
                bottom: 0,
                zIndex: 100,
                width: "100%",
                height: "10%",
                margin: "0px",
                boxShadow:
                  "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)"
              }}
              alignItems="center"
            >
              <Grid item xs={12}>
                <Typography align="center">
                  <Button
                    size="large"
                    variant="filled"
                    style={{
                      color: "white",
                      backgroundColor: "#3D83E1",
                      width: "90%",
                      maxWidth: "350px"
                    }}
                    onClick={this.PlaceOrder}
                  >
                    Place Order
                  </Button>
                </Typography>
              </Grid>
            </Grid>

            {/* ---------------------------------------------------------------------------------------- */}
            <Container style={{ marginTop: "70px", marginBottom: "20px" }}>
              <Grid container>
                <Grid item xs={12}>
                  <TextField
                    id="filled-with-placeholder"
                    label="Mobile Number "
                    placeholder="Mobile Number"
                    fullWidth
                    margin="normal"
                    variant="filled"
                    onChange={this.myChangeHandler}
                    name="mob"
                    value={this.state.mob}
                    inputProps={{ maxLength: 10 }}
                  />
                  {this.state.errormob !== "" ? (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      ERROR: {this.state.errormob}
                    </p>
                  ) : null}
                </Grid>

            
                <Grid item xs={12}>
                  <TextField
                    id="filled-with-placeholder"
                    label=" PNR Number"
                    placeholder="PNR Number"
                    fullWidth
                    margin="normal"
                    variant="filled"
                    onChange={this.myChangeHandler}
                    name="pnr"
                    value={this.state.pnr}
                    inputProps={{ maxLength: 10 }}
                  />
                  {this.state.errorpnr !== "" ? (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      ERROR: {this.state.errorpnr}
                    </p>
                  ) : null}
                </Grid>
               
                <Grid item xs={12}>
                  <TextField
                    id="filled-with-placeholder"
                    label="Email ID"
                    placeholder="Email_Id"
                    fullWidth
                    margin="normal"
                    variant="filled"
                    onChange={this.myChangeHandler}
                    name="email"
                    value={this.state.email}
                  
                  />
                  {this.state.erroremail !== "" ? (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      ERROR: {this.state.erroremail}
                    </p>
                  ) : null}
                </Grid>










                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      id="filled-with-placeholder"
                      label="Coach"
                      placeholder="Coach"
                      margin="normal"
                      variant="filled"
                      onChange={this.myChangeHandler}
                      name="coach"
                      value={this.state.coach}
                    />
                    {this.state.errorcoach !== "" ? (
                      <p style={{ color: "red", fontSize: "12px" }}>
                        ERROR: {this.state.errorcoach}
                      </p>
                    ) : null}
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      id="filled-with-placeholder"
                      label="Seat"
                      // style={{width:"100%"}}
                      placeholder="Seat"
                      style={{ float: "right" }}
                      type="number"
                      margin="normal"
                      variant="filled"
                      onChange={this.myChangeHandler}
                      name="seat"
                      value={this.state.seat}
                    />
                    {this.state.errorseat !== "" ? (
                      <p style={{ color: "red", fontSize: "12px" }}>
                        ERROR: {this.state.errorseat}
                      </p>
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>
            </Container>

            <div style={{ marginTop: "5px", marginBottom: "25px" }}>
              <Typography align="center">
                Your order will be placed as
              </Typography>
              <Typography align="center" style={{ fontWeight: "bold" }}>
                Cash On Delivery
              </Typography>
            </div>

            {/* -------------------------------------------------------------------------------------------- */}

            <Container style={{ marginBottom: "60px" }}>
              <Typography align="center">
                <span style={{ fontSize: 18 }}> Order Summary </span>
              </Typography>

              <Grid
                container
                style={{
                  backgroundColor: "#F1F1F1",
                  padding: 5,
                  color: "#726c6c"
                }}
              >
                {x}

                <Grid item xs={12}>
                  <Divider style={{ margin: 1 }} />
                  <Grid container>
                    <Grid item xs={4} />

                    <Grid item xs={5}>
                      <span style={{ marginLeft: 30 }}>Total</span>
                    </Grid>

                    <Grid item xs={3}>
                      <span style={{ float: "right", marginRight: 5 }}>
                        {" "}
                        ₹{this.props.topay}{" "}
                      </span>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={4} />

                    <Grid item xs={5}>
                      <span style={{ marginLeft: 30 }}>To Pay</span>
                    </Grid>

                    <Grid item xs={3}>
                      <span style={{ float: "right", marginRight: 5 }}>
                        {" "}
                        ₹{this.props.topay}
                      </span>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Container>
          </Fragment>
        );
      } else {
        result = (
          <Container style={{ marginTop: "50%", textAlign: "center" }}>
            <span style={{ fontSize: "14px" }}> {this.state.error} </span>
          </Container>
        );
      }
    } else {
      result = (
        <Container>
          <Typography
            variant="h5"
            color="textSecondary"
            align="center"
            style={{ marginBottom: 150 }}
          >
           
          </Typography>
          <div style={{ textAlign: "center",marginBottom:5 }}>
            <CustomizedProgressBars />
          </div>
          <Typography
            variant="h5"
            color="textSecondary"
            align="center"
        
          >
            Placing the Order
          </Typography>
        </Container>
      );
    }

    return (
      <Fragment>
        <Button
          variant="contained"
          style={{
            color: "white",
            width: "95%",
            backgroundColor: "#3D83E1",
            maxWidth: 350
          }}
          onClick={
            this.props.match.params.minOrder <= Math.trunc(this.props.topay)
              ? this.handleClickOpen
              : this.minR
          }
          id="isc3"
        >
          Confirm Order
        </Button>

        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          {/* -----------------------------    */}
          <Fragment>
            <Grid
              container
              alignItems="center"
              spacing={1}
              style={{
                backgroundColor: "#45A04A",
                position: "fixed",
                top: 0,
                zIndex: 100,
                margin: "0px"
              }}
            >
              <Grid item xs={2} style={{ marginLeft: "10px" }}>
                <IconButton
                  edge="start"
                  style={{ color: "white" }}
                  onClick={this.handleClose}
                  aria-label="Close"
                >
                  <CloseIcon />
                </IconButton>
              </Grid>
              <Grid item xs={8} style={{ fontSize: "18px", color: "white" }}>
                Confirm Order
              </Grid>
            </Grid>
            {result}
          </Fragment>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    cart: state.menuR.cart,
    pnr: state.outletR.pnr
  };
};
export default connect(mapStateToProps)(withRouter(INBOX));
